// extracted by mini-css-extract-plugin
module.exports = {"button":"index-module--button--VhN9B"};